import { Col, Container, Row } from "react-grid-system";
// import { Link } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import colors from "../assets/colors/colors";
import Header from "../components/layout/Header";
import { Link } from "react-router-dom";
import SectionPricings from "../components/SectionPricings";
import { BsCamera } from "react-icons/bs";
import { BiQrScan } from "react-icons/bi";
import { FiMousePointer } from "react-icons/fi";

interface StyledInterface {
  color: any;
}

export default function Home() {
  const [t] = useTranslation("global");

  const customers = [
    {
      name: "Na' Popi",
      image:
        "https://firebasestorage.googleapis.com/v0/b/digitalmenu-e82c4.appspot.com/o/upload_images%2Fb98424df-04b9-40ef-b25e-480f1a1f78b8?alt=media",
      location: "",
      link: "NkkeUIZe4KOJx8erDUjzqLYlgto2",
    },
    {
      name: "Restaurante  Primitivo",
      image:
        "https://firebasestorage.googleapis.com/v0/b/digitalmenu-e82c4.appspot.com/o/upload_images%2Fc416de90-2b40-4edb-88d0-74202dd13c49?alt=media",
      location: "",
      link: "PhpB4BRwJNbjXsMIoeeuqhhUjCQ2",
    },
    {
      name: "The Factory Burger",
      image:
        "https://firebasestorage.googleapis.com/v0/b/digitalmenu-e82c4.appspot.com/o/upload_images%2F92fae1fc-f6d4-4e9a-adb5-89f7281a642c?alt=media&token=b89f83d2-9f43-40e3-af63-bcd5c3bf3dad",
      location: "",
      link: "uQyOouQ5GAS27NNclmo0jZ0xCQy2",
    },
  ];

  return (
    <>
      <Header />
      <HomeContent color={colors}>
        <section className="inicio">
          <Container>
            <Row align="center" justify="center">
              <Col xs={12} md={4}>
                <h1>{t("home.section_1")}🚀</h1>
                <h4>{t("home.description_1")}</h4>
                <Link
                  to={"/register"}
                  className="btn btn-primary mx-auto px-4 mt-3 w-100"
                >
                  {t("home.enter_free")}
                </Link>
              </Col>
              <Col xs={12} md={8}>
                <div className="images">
                  <img
                    className="my-4"
                    src={"https://i.postimg.cc/RhH9Rxgr/Device-1.png"}
                    alt=""
                  />
                  <img
                    className="my-4"
                    src={"https://i.postimg.cc/qvjRg0YQ/Device-2.png"}
                    alt=""
                  />
                </div>
                <div className="text-center">
                  <Link
                    className="btn btn-secondary"
                    to="menu/NkkeUIZe4KOJx8erDUjzqLYlgto2"
                  >
                    {t("home.view_menu_complete")}
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <SectionSomeCustomers className="mt-5 text-center">
          <h2>{t("home.some_customers")}:</h2>
          <Container>
            <Row align="center" justify="center" style={{ minHeight: "10vh" }}>
              {customers.map((dt, key) => (
                <Col xs={3} md={4} className="text-center" key={key}>
                  <Link to={`menu/${dt.link}`}>
                    <div className="cardCustomer">
                      <img
                        style={{
                          width: "65px",
                          height: "65px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                        src={dt.image}
                        alt={dt.name + " Link logo"}
                      />
                    </div>
                  </Link>
                </Col>
              ))}
            </Row>
          </Container>
        </SectionSomeCustomers>
        {/* QR CODE EXAMPLE */}
        <section className="wi">
          <Container>
            <Row align="center" justify="center">
              <Col xs={12} md={8}>
                <h1>Transformación a lo último de tecnología.</h1>
                <h4>
                  Tus clientes podrán acceder al menú a través de un clic o
                  escaneando el código QR
                </h4>
              </Col>
              <Col xs={12} md={4}>
                <h4 className="text-center">
                  Escanéame
                  <BiQrScan />
                </h4>
                <div className="images">
                  <Link to={"/menu/PhpB4BRwJNbjXsMIoeeuqhhUjCQ2"}>
                    <img
                      src="https://i.postimg.cc/4NL9B0zK/qr-code-3.png"
                      style={{ width: "70%" }}
                      alt=""
                    />
                  </Link>
                </div>
                <h2 className="text-center">
                  O click <FiMousePointer />
                </h2>
              </Col>
            </Row>
          </Container>
        </section>
        {/* lanza tu menu rapido */}
        <section className="wi">
          <Container>
            <Row align="center" justify="center">
              <Col xs={12} md={4}>
                <h1>{t("home.launch_menu")}!⚡</h1>
                <h4>{t("home.launch_objetive")}</h4>
                <h4>{t("home.launch_objetive_2")}🛴</h4>
                <Link
                  to={"/register"}
                  className="btn btn-primary mx-auto px-4 my-3"
                >
                  {t("create_account")}
                </Link>
              </Col>
              <Col xs={12} md={8}>
                <div className="images">
                  <img src="https://i.postimg.cc/66zkG3ck/ad.png" alt="" />
                  <img src="https://i.postimg.cc/G3qphby2/Device.png" alt="" />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* whi menudr */}
        <section className="wi mt-5">
          <Container>
            <Row align="center" justify="center">
              <Col xs={12} md={4}>
                <h1> {t("home.business_type")} </h1>
                <h4>{t("home.descitption_business")}</h4>
              </Col>
              <Col xs={12} md={8}>
                <img
                  src="https://i.postimg.cc/y8ft29bB/editexample2.png"
                  alt=""
                  style={{ width: "50%" }}
                />
              </Col>
            </Row>
          </Container>
        </section>
        <section className="wi mt-5 text-center">
          <Container>
            <h1 className="mt-2"> {t("home.plans_prices")} </h1>
            <SectionPricings />
          </Container>
        </section>
      </HomeContent>
    </>
  );
}

const HomeContent = styled.div<StyledInterface>`
  overflow-y: hidden !important;
  width: 100%;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // background: #3498db36;
  background: #3458e617;
  padding-top: 2em;
  padding-bottom: 8em;
  section {
    margin: 2em 0;
  }
  button {
    font-weight: 500;
  }
  .inicio {
    text-align: left;
    padding: 5em 0;

    @media screen and (max-width: 500px) {
      padding: 0em 0;
    }
  }
  .wi {
    img {
      width: 100%;
      text-align: center;
      border-radius: 8px;
    }
  }
  h1,
  h2 {
    margin: 0.5em 0;
    font-size: 2.5em;
    font-weight: 900;
    color: ${(props) => props.color.black};
    font-family: sans-serif;
    @media screen and (max-width: 500px) {
      font-size: 1.8em;
    }
  }
  h3 {
    font-weight: bold;
    color: ${(props) => props.color.black};
  }
  h4 {
    color: ${(props) => props.color.black2};
    font-weight: 400;
  }

  .images {
    width: 100%;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    img {
      width: 240px;
      text-align: center;
      margin: 0 0.5em;
      border-radius: 8px;
      objet-fit: cover;
    }
    @media screen and (max-width: 800px) {
      font-size: 1.8em;
      img {
        width: 130px;
        text-align: center;
        margin: 0 0.5em;
        border-radius: 8px;
        objet-fit: cover;
      }
    }
  }
`;

const SectionSomeCustomers = styled.section`
  width: 100%;
  .cardCustomer {
    width: 100%;
    /* background:#ffffff60; */
    padding: 0em 1em;
    /* box-shadow: 0px 0px 2px #1616162f; */
    border-radius: 6px;
    h5 {
      padding: 0.5em;
    }
  }
`;
